import {Modal, Spin} from "antd";
import {delay} from "@lib/utils";
import React from "react";

let elemDiv:any = null;
let isVisible = false;

//This loading overlay exists outside of the normal React DOM and so is coded with basic HTML and uses non React attach and remove.
export const showHideLoadingOverlay = async (visible) => {
    if(elemDiv === null) {
        elemDiv = document.createElement('div');
        elemDiv.style.cssText = 'position:fixed; top: 0px; left: 0px; width: 100vw; height: 100vh; z-index: 9999; background: rgba(0,0,0,0.35);';
        elemDiv.classList.add('flex-vertical-center');
        elemDiv.classList.add('flex-align-center');
        elemDiv.classList.add('ant-layout');
        elemDiv.innerHTML = '<div class="ant-spin ant-spin-lg ant-spin-spinning" aria-live="polite" aria-busy="true"><span role="img" aria-label="loading" class="anticon anticon-loading anticon-spin ant-spin-dot" style="font-size: 24px;"><svg viewBox="0 0 1024 1024" focusable="false" data-icon="loading" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path></svg></span></div>';
    }

    if (visible !== isVisible) {
        isVisible = visible;
        if (!visible) elemDiv.remove();
        if (visible) document.body.appendChild(elemDiv);
    }
};